<template>
  <v-layout v-if="!['LandingPageM' ,'LandingPageE'].includes($route.name)" justify-center align-center>
    <v-container v-if="show" id="fullheader" fluid pa-0 ref="fullHeaderContainer" v-resize="onResize">
      <v-toolbar  dark flat color="#1f97b9" height="auto">
        <v-layout v-if="!['Mudanza Rapida'].includes($route.name)" justify-center align-center>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn flat class="py-2 px-4" :to="{ name: 'home' }" @click="eventTracker('Inicio_Header')">Inicio</v-btn>
            <v-menu offset-y>
              <v-btn slot="activator" flat class="py-2 px-4">Cotizar <v-icon small right class="ml-1">fas fa-caret-down</v-icon></v-btn>
              <v-list class="submenu">
                <!-- <v-btn flat class="py-2 my-0 p btn-content-left" block @click="eventTracker('Mudanza_Header')" :to="{ name: 'mudanza' }" >Mudanza Domestica</v-btn> -->
                <v-btn flat class="py-2 my-0 p btn-content-left" block @click="goToWS(1)">Mudanza Domestica</v-btn>
                <!-- <v-btn flat class="py-2 my-0 p btn-content-left" block :to="{ name: 'Express' }" @click="eventTracker('Cotizacion_Express_Header')">Flete Domestico</v-btn> -->
                <!-- <v-btn flat class="py-2 my-0 p btn-content-left" block :to="{ name: 'contacto' }" @click="eventTracker('Negocios_y_otros_Header')">Negocios y Otros</v-btn> -->
                <v-btn flat class="py-2 my-0 p btn-content-left" block @click="goToWS(2)">Negocios y Otros</v-btn>
                <!-- <v-btn flat class="py-2 my-0 p btn-content-left" block :to="{ name: 'contacto' }">Cotización Básica</v-btn> -->
              </v-list>
            </v-menu>
            <v-btn flat class="py-2 px-4" :to="{ name: 'nosotros' }" @click="eventTracker('Sobre_Duo_Header')">Sobre Duo</v-btn>
            <v-btn flat class="py-2 px-4" :to="{ name: 'preguntas' }" @click="eventTracker('Preguntas_Header')">Preguntas</v-btn>
            <v-btn flat class="py-2 px-4" :to="{ name: 'clientes' }" @click="eventTracker('Clientes_Header')">Clientes</v-btn>
            <v-btn flat class="py-2 px-4" :to="{ name: 'Blog' }" @click="eventTracker('Blog_Header')">Blog</v-btn>
            <!-- <v-btn flat class="py-2 px-4" :to="{ name: 'contacto' }">Contacto</v-btn> -->
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <v-btn slot="activator" flat class="py-2 px-4">Convenios <v-icon small right class="ml-1">fas fa-caret-down</v-icon></v-btn>
              <v-list class="submenu">
                <v-btn v-if="$store.state.idCliente === '' " flat class="py-2 my-0 p btn-content-left" :to="{ name: 'register' }">Registro</v-btn>
                <v-btn v-if="$store.state.idCliente != '' " flat class="py-2 my-0 p btn-content-left" :to="{ name: 'portalCliente'}">Mi Portal</v-btn>
                <v-btn v-if="$store.state.idCliente === '' " flat class="py-2 my-0 p  btn-content-left" @click="openLogin">Login</v-btn>
                <v-btn v-if="$store.state.idCliente != '' " flat class="py-2 my-0 p btn-content-left" @click="closeSesion" :to="{ name: 'home' }">Cerrar Sesion</v-btn>
              </v-list>
            </v-menu>
            <!--<v-btn flat class="py-2 px-4" :to="{ name: 'seguimiento' }" @click="eventTracker('Seguimiento_Header')">Seguimiento</v-btn>-->
          </v-toolbar-items>
          <!-- <v-container pa-0 fluid class="hidden-sm-and-up">
            <v-layout row wrap py-0 align-center class="text-xs-center">
              <v-flex md6 sm6 xs6 align-center>
                <a href="mailto:info@duoapp.cl" class="link-header"><img :src='require("../../assets/static/img/email-2w.png")' max-width="20" style="width: 30px;"> --> <!-- <p class="caption" style="color:white; margin-bottom: 0;line-height: 12px;">info@duoapp.cl</p></a> -->
              <!-- </v-flex>
              <v-flex md6 sm6 xs6 align-center> -->
                <!-- <a href="https://wa.me/56965909598" class="link-header" target="_blank"><v-icon size="30" left>fab fa-whatsapp</v-icon></a>  <p class="caption" style="color:white; margin-bottom: 0;"><a href="tel:56966919889" class="link-header">+569 6691 9889</a></p> -->
              <!-- </v-flex>
            </v-layout>
          </v-container> -->
        </v-layout>
      </v-toolbar>
      <v-toolbar height="auto" class="hidden-sm-and-down">
        <v-layout row wrap py-2 px-5 justify-center align-center class="inner-container" mx-auto>
          <v-flex md4 sm4 xs12 justify-center align-center>
            <v-layout row wrap py-0 px-5 align-center>
              <v-img class="link" :src='require("../../assets/static/img/logo-hd-1.png")' max-height="70" max-width="180" contain v-on:click="goTo('home', 'Inicio_Logo')"></v-img>
            </v-layout>
          </v-flex>
          <v-flex md3 sm4 xs12 justify-center align-center>
            <v-layout row wrap py-0 px-5 align-center>
              <!-- <v-img class="link" :src='require("../../assets/static/img/webpay-1.png")' max-height="60" max-width="180" contain></v-img> -->
            </v-layout>
          </v-flex>
          <v-flex md5 sm6 xs12 justify-end align-center>
            <v-layout row wrap py-0 px-5 justify-end align-center>
              <!-- <a href="mailto:info@duoapp.cl" class="link-header fix-flex"> --><!-- <span style="color:#1f97b9;" class="subheading mr-4">info@duoapp.cl</span> --> <!-- <img :src='require("../../assets/static/img/email-2.png")' max-width="20px" style="width: 35px;margin-right:16px;"></a> -->
              <h1 v-if="!['Mudanza Rapida', 'Express'].includes($route.name)" style="font-size: 35px; text-align: center; color: #1f97b9;" >Fletes | Mudanzas</h1>
              <h1 v-if="['Mudanza Rapida', 'Express'].includes($route.name)" style="font-size: 35px; text-align: center; color: #1f97b9;" >Cotización Express</h1>
              <h1 v-if="['Mudanza Rapida', 'Express'].includes($route.name)" style="font-size: 20px; text-align: center; color: #1f97b9;" >Maximo 5 Artículos</h1>
            </v-layout>
  <!--           <v-layout row wrap py-0 px-5 justify-end align-center>
              <a href="tel:56965909598" class="link-header"><span style="color:#1f97b9;" class="subheading mr-4">+569 6590 9598</span></a> <a href="https://wa.me/56965909598" class="link-header" target="_blank"><v-icon color="#1f97b9" x-large left>fab fa-whatsapp</v-icon></a>
            </v-layout> -->
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-toolbar height="auto" class="hidden-sm-and-up">
        <v-layout row wrap py-2 px-0>
          <v-flex md6 sm8 xs8>
            <v-layout row wrap py-0>
              <v-img class="link" :src='require("../../assets/static/img/logo-hd-1.png")' max-height="60" max-width="153" contain v-on:click="goTo('home', 'Inicio_Logo')"></v-img>
            </v-layout>
          </v-flex>
          <v-flex md6 sm4 xs4 align-self-center>
            <v-layout row wrap py-0 justify-end class="menu-mobile text-xs-center">
              <v-menu bottom left :nudge-width="200" transition="slide-x-transition" content-class="menu-mobile-principal">
                <template slot="activator">
                  <v-btn
                    dark
                    icon
                  >
                    <v-icon color="#1f97b9" x-large left>fas fa-bars</v-icon>
                  </v-btn>
                </template>
                <h2 class="text-xs-center py-3 white--text menu-title">Menú</h2>
                <v-divider dark></v-divider>

                <v-list class="py-0 mt-4 list-menu">
                  <h4 class="text-xs-center py-3 white--text menu-title">Cotiza</h4>
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goToWS(1)" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Artículos Hogar</v-list-tile>
                  <!-- <v-list-tile class="py-2 px-4 link" @click="goTo('mudanza', 'Mudanza_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Artículos Hogar</v-list-tile> -->
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goToWS(2)" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Otros Artículos</v-list-tile>
                  <!-- <v-list-tile class="py-2 px-4 link" @click="goTo('contacto', 'Negocios_y_otros_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Otros Artículos</v-list-tile> -->
                  <h4 class="text-xs-center py-2 white--text menu-title"></h4>
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goTo('home', 'Inicio_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Inicio</v-list-tile>
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goTo('nosotros', 'Sobre_Duo_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Sobre Duo</v-list-tile>
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goTo('preguntas', 'Preguntas_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Preguntas</v-list-tile>
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goTo('clientes', 'Clientes_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Clientes</v-list-tile>
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goTo('Blog', 'Blog_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Blog</v-list-tile>
                  <v-divider dark></v-divider>
                  <v-list-tile class="py-2 px-4 link" @click="goTo('contacto', 'Negocios_y_otros_Mobile_Header')" ><v-icon color="white" small left>fas fa-chevron-right</v-icon> Contacto</v-list-tile>
                </v-list>
              </v-menu>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-toolbar>
    </v-container>
  </v-layout> 
</template>

<script>
  import * as firebase from 'firebase/app'
  import 'firebase/auth'
  import 'firebase/firestore'
  import { EventBus } from '../../events.js'
  import resize from 'vue-resize-directive'
  export default {
    name: 'Header',
    directives: {
      resize
    },
    data () {
			return {
        show: true
      }
    },
    methods: {
      goToWS(tipo){
			  const texto = tipo == 1 ? '¡Hola! Quiero cotizar una mudanza de hogar.' : '¡Hola! Quiero cotizar un flete para Empresa.'
        const url = 'https://wa.me/56996711666?text=' + texto
        const windowOpen = window.open(url)
        windowOpen
      },
      goTo( route, tipo){
        this.eventTracker(tipo)
        this.$router.push({name: route})
      },
      onResize(){
        EventBus.$emit('headHeight', this.$refs.fullHeaderContainer.clientHeight)
      },
      openLogin() {
        EventBus.$emit('openLogin', true)
      },
      closeSesion() {
        const self = this
        
        firebase.auth().signOut().then(() => {
            // Sign-out successful.
            self.loged = false
            self.$store.state.idCliente = ''
            
          }).catch((error) => {
            // An error happened.
          });
      },
      eventTracker(tipo) {
        console.log('entra aqui')
        gtag('event', tipo, {
          'event_category' : tipo,
          'event_label' : tipo
        })
      }
    },
    watch:{
      $route (to, from){
        if(to.name == 'home'){
          this.onResize()
        }
        this.$route.query.me ? this.show = false : this.show = true
      }
    }
  }
  </script>